import React, { useEffect, useLayoutEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Modal, Button, Group, Text } from "@mantine/core";
import { signOut, onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../../firebase/FirebaseCredential";
import {
  collection,
  query,
  where,
  getDocs,
  collectionGroup,
} from "firebase/firestore";

interface RoleGuardProviderProps {
  companyId: string | null;
  children: React.ReactNode;
  userId: string | undefined | null;
  userClaims?: any;
}

const ALLOWED_PATH_PATTERNS = [
  "/company/mapbranches",
  "/choose/companytype/:companyId?",
  "/create/company/:companyId?",
  "/create/companywizard/:companyId?",
];

// Match path to allowed route pattern with optional params
const matchPath = (pattern: string, actualPath: string): boolean => {
  const patternParts = pattern.split("/").filter(Boolean);
  const pathParts = actualPath.split("/").filter(Boolean);

  for (let i = 0; i < patternParts.length; i++) {
    const patternSegment = patternParts[i];
    const pathSegment = pathParts[i];

    if (patternSegment?.startsWith(":")) {
      const isOptional = patternSegment.endsWith("?");
      if (!pathSegment && !isOptional) return false;
    } else if (patternSegment !== pathSegment) {
      return false;
    }
  }

  return pathParts.length <= patternParts.length;
};

const isAllowedRoute = (path: string): boolean => {
  return ALLOWED_PATH_PATTERNS.some((pattern) => matchPath(pattern, path));
};

const RoleGuardProvider: React.FC<RoleGuardProviderProps> = ({
  companyId,
  userId,
  userClaims,
  children,
}) => {
  const [authInitialized, setAuthInitialized] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { companyId: paramsID } = useParams();

  useEffect (() => {
    const unsubscribe = onAuthStateChanged(auth, () => {
      setAuthInitialized(true);
    });
    return () => unsubscribe();
  }, []);

  useEffect (() => {
    if (!authInitialized || !userId) return;

    // const isSuperAdmin = Boolean(userClaims?.super_admin);
    const currentPath = location.pathname;

    if (paramsID) {
      sessionStorage.setItem("paramsID", paramsID);
    }

    const logoutAndRedirect = async () => {
      try {
        await signOut(auth);
      } catch (err) {
        console.error("Sign out error:", err);
      } finally {
        navigate("/");
      }
    };

    // const checkProfile = async () => {
    //   try {
    //     const benchCollectionRef = collectionGroup(db, "roles");
    //     const q = query(
    //       benchCollectionRef,
    //       where("uid", "==", userId),
    //       where("company_id", "!=", null)
    //     );
    //     const snapshot = await getDocs(q);
    //     // const isSuperAdmin = Boolean(userClaims?.super_admin);
    //     const hasRole = !snapshot.empty;
    
    //     // 🚫 Block users who have a role and are NOT super admins
    //     if (hasRole) {
    //       console.warn("Blocked: Has role");
    //       await logoutAndRedirect();
    //     }
    //   } catch (error) {
    //     console.error("Error checking profile:", error);
    //   }
    // };

    if (isAllowedRoute(currentPath) && currentPath !== "/subscriptionpage") {
      console.log("%cAllowed route " + currentPath, "color: green;");
      // checkProfile();
    }
  }, [
    authInitialized,
    companyId,
    location.pathname,
    userId,
    userClaims,
    navigate,
    paramsID,
  ]);
  return <>{children}</>;
};

export default RoleGuardProvider;
